import moment from "moment";
import Select from "react-select";
import Cards from "react-credit-cards";
import React from "react";
import {
  Form,
  FormGroup,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledCollapse,
  CustomInput,
} from "reactstrap";

import * as Server from "../../Server";
import Page from "../../components/Page";
import PageSpinner from "../../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

class RushUserEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      allPlayers: [],
      allPlayersOptions: [],
      selectedPlayer: null,
      pendingEventPlayers: [],
      pendingEvents: [],
      eventPaymentModal: false,
      allAdultsOptions: [],
      selectedAdult: null,
      selectedCard: {},
      stripeCards: [],
      paymentMethodId: "",
      type: "",
      addCardCollapse: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      eventPriceDetails: {},
      allEventsPriceDetails: [],
      fullPayment: true,
      paymentConfirmationModal: false,
      eventId: null,
      failedTransactions: [],
      failedTransactionsViewModal: false,
      SPIRegistered: false,
    };
  }

  componentDidMount() {
    this.getParents();
  }

  getParents = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "social/register/user?requestFrom=webApp",
        method: "GET",
      });
      if (response) {
        let allPlayersOptions = response.allPlayers.map((player) => ({
          label: `${player.data.firstName} ${player.data.lastName}`,
          value: player._id,
        }));
        let selectedPlayer = allPlayersOptions.length
          ? allPlayersOptions[0]
          : null;
        let child = response.allPlayers.length ? response.allPlayers[0] : null;
        let parentIds = response.users.map((user) => user._id);
        let stripeCards = response.users.reduce((preVal, curVal) => {
          preVal.push(
            ...curVal.stripeCards.map((card) =>
              Object.assign(card, {
                name: `${curVal.data.firstName} ${curVal.data.lastName}`,
                parentId: curVal._id,
              })
            )
          );
          return preVal;
        }, []);
        let allAdultsOptions = [
          ...response.users.map((user) => ({
            label: `${user.data.firstName} ${user.data.lastName}`,
            value: user._id,
          })),
        ];
        this.setState(
          {
            showLoader: false,
            stripeCards,
            selectedPlayer,
            allAdultsOptions,
            allPlayersOptions,
            allPlayers: response.allPlayers,
            SPIRegistered: child ? child.SPIRegistered : false,
          },
          () =>
            this.getPendingEvents(
              parentIds,
              response.users.length ? response.users[0].clubId : null,
              selectedPlayer ? selectedPlayer.value : null
            )
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getPendingEvents = async (parentIds, clubId, childId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccerapp/pending/events",
        method: "POST",
        data: {
          SPIEvent: this.state.SPIRegistered,
          clubId,
          parentIds,
        },
        token: "marketplaceAccessToken",
      });
      if (response) {
        let child = response.childs.find((child) => child._id === childId);
        let failedTransactions = response.childs.reduce((preVal, curVal) => {
          preVal.push(
            ...curVal.reprocessTransactions.map((reprocessTransaction) =>
              Object.assign(reprocessTransaction, {
                name: `${curVal.data.firstName} ${curVal.data.lastName}`,
              })
            )
          );
          return preVal;
        }, []);
        this.setState({
          showLoader: false,
          failedTransactions,
          failedTransactionsViewModal: failedTransactions.length ? true : false,
          pendingEventPlayers: response.childs,
          pendingEvents: child ? child.pendingEvent : [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getProcessingFees = async (campId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/processingFee",
        method: "POST",
        data: {
          campId,
          childId: this.state.selectedPlayer
            ? this.state.selectedPlayer.value
            : null,
          SPIEvent: this.state.SPIRegistered,
        },
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({
          showLoader: false,
          eventPriceDetails: response,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      if (!this.state.selectedAdult) throw Error("Select the adult");
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.selectedAdult.value,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          addCardCollapse: false,
        });
        this.getParents();
        this.toggleEventPaymentModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  payForEvent = async (event) => {
    event.preventDefault();
    try {
      if (!this.state.selectedCard || !this.state.selectedCard.paymentMethodId)
        throw Error("Select credit card for payment");
      this.setState({ showLoader: true });
      let response;
      if (this.state.fullPayment) {
        response = await Server.request({
          url: "rushsoccer/stripe/pay",
          method: "POST",
          data: {
            SPIEvent: this.state.SPIRegistered,
            sendEmail: true,
            APIVersion: "v2",
            paymentFor: "child",
            paymentMethodId: this.state.selectedCard.paymentMethodId,
            campId: this.state.eventId,
            parentId: this.state.selectedCard.parentId,
            childId: this.state.selectedPlayer
              ? this.state.selectedPlayer.value
              : null,
            paymentDoneFrom: "webapp",
          },
          token: "marketplaceAccessToken",
        });
      } else {
        response = await Server.request({
          url: "rushsoccer/stripe/interval/pay",
          method: "POST",
          data: {
            SPIEvent: this.state.SPIRegistered,
            sendEmail: true,
            APIVersion: "v2",
            interval: "month",
            paymentFor: "child",
            paymentMethodId: this.state.selectedCard.paymentMethodId,
            campId: this.state.eventId,
            parentId: this.state.selectedCard.parentId,
            childId: this.state.selectedPlayer
              ? this.state.selectedPlayer.value
              : null,
            paymentDoneFrom: "webapp",
          },
          token: "marketplaceAccessToken",
        });
      }

      if (response) {
        this.setState({
          showLoader: false,
        });
        this.togglePaymentConfirmationModal();
        this.toggleEventPaymentModal();
        this.getParents();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  togglePaymentConfirmationModal = () => {
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
    });
  };

  toggleEventPaymentModal = async (campId) => {
    if (campId) {
      this.getProcessingFees(campId);
    }
    this.setState({
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      addCardCollapse: false,
      eventId: campId ? campId : null,
      selectedAdult: null,
      selectedCard: {},
      fullPayment: true,
      eventPaymentModal: !this.state.eventPaymentModal,
    });
  };

  toggleFailedTransactionsViewModal = () => {
    this.setState({
      failedTransactionsViewModal: !this.state.failedTransactionsViewModal,
    });
  };

  renderPlayerPaymentDetailPage = async (camp, playerName, transactionId) => {
    Object.assign(camp, { transactionId, campName: camp.name });
    this.props.history.push({
      pathname: "/rushUserPaymentDetails",
      state: {
        camp,
        playerName,
      },
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Events" breadcrumbs={[{ name: "Events", active: true }]}>
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Row className="mb-3">
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <Label for="name">Select Player :</Label>
                      <Select
                        value={this.state.selectedPlayer}
                        options={this.state.allPlayersOptions}
                        onChange={(result) => {
                          let child = this.state.pendingEventPlayers.find(
                            (player) => player._id === result.value
                          );
                          this.setState({
                            pendingEvents: child ? child.pendingEvent : [],
                            selectedPlayer: result,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>Team Name - Event Name</th>
                        <th>Price</th>
                        <th>StartingAt</th>
                        <th>EndingAt</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.pendingEvents.length ? (
                        this.state.pendingEvents.map((event, index) => (
                          <tr key={index}>
                            <td>{event.name}</td>
                            <td>{event.price}</td>
                            <td>
                              {event.startingAt
                                ? moment.utc(event.startingAt).format("LL")
                                : "-"}
                            </td>
                            <td>
                              {event.endingAt
                                ? moment.utc(event.endingAt).format("LL")
                                : "-"}
                            </td>
                            <td>
                              <Button
                                color="primary"
                                onClick={() =>
                                  this.toggleEventPaymentModal(event._id)
                                }
                              >
                                Pay
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No events found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.eventPaymentModal ? (
            <Modal
              isOpen={this.state.eventPaymentModal}
              toggle={(event) => this.toggleEventPaymentModal()}
              className="modal-lg"
            >
              <ModalHeader toggle={() => this.toggleEventPaymentModal()}>
                Payment :
              </ModalHeader>
              <ModalBody>
                <Row
                  style={
                    this.state.addCardCollapse
                      ? {
                          borderBottom: "1px solid #dee2e6",
                          marginBottom: "10px",
                        }
                      : null
                  }
                >
                  <Col>
                    <Button
                      id="toggler"
                      className="float-right mb-2"
                      onClick={() => {
                        this.setState({
                          addCardCollapse: !this.state.addCardCollapse,
                        });
                      }}
                    >
                      Add Credit Card
                    </Button>
                  </Col>
                </Row>
                <UncontrolledCollapse
                  toggler="#toggler"
                  isOpen={this.state.addCardCollapse}
                >
                  <Form className="form" onSubmit={this.addCreditCard}>
                    <Row style={{ padding: "0px 15px" }}>
                      <Col style={{ margin: "auto" }}>
                        <Cards
                          cvc={this.state.cvc}
                          expiry={this.state.expiry}
                          focused={this.state.focus}
                          name={this.state.name}
                          number={this.state.number}
                          callback={(event) => {
                            this.setState({ cardType: event.issuer });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-3">
                        <Label>Select Adult</Label>
                        <Select
                          placeholder="Select the Adult"
                          value={this.state.selectedAdult}
                          options={this.state.allAdultsOptions}
                          onChange={(result) =>
                            this.setState({
                              selectedAdult: result,
                            })
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-3">
                        <>
                          <Label>Card Number</Label>
                          <FormGroup>
                            <Input
                              id="number"
                              name="number"
                              type="text"
                              maxLength="16"
                              value={this.state.number}
                              onChange={(event) =>
                                this.setState({
                                  number: event.target.value,
                                  focus: "number",
                                })
                              }
                              placeholder="CARD NUMBER"
                              required
                            />
                          </FormGroup>
                        </>
                        <>
                          <Label>Card Name</Label>
                          <FormGroup>
                            <Input
                              id="name"
                              name="name"
                              type="text"
                              value={this.state.name}
                              onChange={(event) =>
                                this.setState({
                                  name: event.target.value,
                                  focus: "name",
                                })
                              }
                              placeholder="CARD NAME"
                              required
                            />
                          </FormGroup>
                        </>
                        <Row>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            <Label>Card Expiration Date</Label>
                            <FormGroup>
                              <Input
                                id="expiry"
                                name="expiry"
                                type="text"
                                maxLength="4"
                                value={this.state.expiry}
                                onChange={(event) =>
                                  this.setState({
                                    expiry: event.target.value,
                                    focus: "expiry",
                                  })
                                }
                                placeholder="MM/YY"
                                required
                              />
                            </FormGroup>
                          </Col>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            <Label>CVC</Label>
                            <FormGroup>
                              <Input
                                id="cvc"
                                name="cvc"
                                type="text"
                                maxLength="4"
                                value={this.state.cvc}
                                onChange={(event) =>
                                  this.setState({
                                    cvc: event.target.value,
                                    focus: "cvc",
                                  })
                                }
                                placeholder="CVC"
                                required
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <>
                          <FormGroup>
                            <Button type="submit" onClick={() => {}}>
                              Add Credit Card
                            </Button>
                          </FormGroup>
                        </>
                      </Col>
                    </Row>
                  </Form>
                </UncontrolledCollapse>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th className={"text-center"}>Select Card</th>
                      <th className={"text-center"}>Adult Name</th>
                      <th className={"text-center"}>Card Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.stripeCards.length ? (
                      this.state.stripeCards.map((card, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>
                            <Input
                              type="checkbox"
                              style={{
                                width: "20px",
                                height: "20px",
                                marginTop: "0px",
                              }}
                              onClick={() =>
                                this.setState({ selectedCard: card })
                              }
                              checked={this.state.selectedCard._id === card._id}
                            ></Input>
                          </td>
                          <td className={"text-center"}>
                            {card.name ? card.name : "-"}
                          </td>
                          <td className={"text-center"}>
                            {card.number ? card.number : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No cards found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <Col
                  style={{
                    padding: "5px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                ></Col>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th colSpan="2" className={"text-center"}>
                          Event Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className={"text-center"}>Event Name</td>
                        <td className={"text-center"}>
                          {this.state.eventPriceDetails.campName
                            ? this.state.eventPriceDetails.campName
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className={"text-center"}>
                          <CustomInput
                            id="fullpayment"
                            type="radio"
                            label="Full Payment"
                            checked={this.state.fullPayment}
                            name="payment"
                            onClick={() =>
                              this.setState({
                                fullPayment: true,
                              })
                            }
                          />
                        </td>
                        <td className={"text-center"}>
                          <CustomInput
                            id="installmentpayment"
                            type="radio"
                            label="Installment payment"
                            checked={!this.state.fullPayment}
                            name="payment"
                            onClick={() =>
                              this.setState({
                                fullPayment: false,
                              })
                            }
                          />
                        </td>
                      </tr>
                      {this.state.fullPayment ? (
                        <>
                          <tr>
                            <td className={"text-center"}>Price</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.price.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Credit Amount</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.creditAmount.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Past Due</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.dueAmount.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Processing Fee</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.processingFee.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Total Price</td>
                            <td className={"text-center"}>
                              $
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.totalPrice.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                        </>
                      ) : this.state.eventPriceDetails.installments &&
                        this.state.eventPriceDetails.installments.length ? (
                        <tr>
                          <td colSpan="2">
                            <Table striped hover responsive>
                              <thead>
                                <tr>
                                  <th className={"text-center"}>
                                    Installment Number
                                  </th>
                                  <th className={"text-center"}>Price</th>
                                  <th className={"text-center"}>Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.eventPriceDetails.installments.map(
                                  (installment, index) => (
                                    <tr key={index}>
                                      <td className={"text-center"}>
                                        {installment.installmentNumber
                                          ? installment.installmentNumber
                                          : "-"}
                                      </td>
                                      <td className={"text-center"}>
                                        $
                                        {installment.totalPrice
                                          ? installment.totalPrice.toFixed(2)
                                          : "0.00"}
                                      </td>
                                      <td className={"text-center"}>
                                        {installment.dueDate
                                          ? moment
                                              .utc(installment.dueDate)
                                              .format("LL")
                                          : "-"}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan="2" className={"text-center"}>
                            No installment payment
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
                <Col
                  style={{
                    padding: "5px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                ></Col>
                <Col
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Button
                    disabled={
                      !this.state.fullPayment &&
                      (this.state.eventPriceDetails.installments &&
                      this.state.eventPriceDetails.installments.length
                        ? false
                        : true)
                    }
                    type="submit"
                    className="ml-2"
                    onClick={() => this.togglePaymentConfirmationModal()}
                  >
                    Pay
                  </Button>
                </Col>
              </ModalBody>
            </Modal>
          ) : null}
          {this.state.paymentConfirmationModal ? (
            <Modal
              isOpen={this.state.paymentConfirmationModal}
              toggle={(event) => this.togglePaymentConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                style={{
                  background: "#f8f9fa",
                }}
                toggle={(event) => this.togglePaymentConfirmationModal()}
              >
                Confirmantion
              </ModalHeader>
              <ModalBody
                style={{
                  background: "#f8f9fa",
                }}
              >
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Are you sure you want to pay?</Label>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter
                style={{
                  background: "#f8f9fa",
                }}
              >
                <Form className="form" onSubmit={this.payForEvent}>
                  <Button type="submit">Pay</Button>
                </Form>
                <Button onClick={() => this.togglePaymentConfirmationModal()}>
                  Cancel
                </Button>{" "}
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.failedTransactions.length &&
          this.state.failedTransactionsViewModal ? (
            <Modal
              isOpen={
                this.state.failedTransactions.length &&
                this.state.failedTransactionsViewModal
              }
              toggle={(event) => this.toggleFailedTransactionsViewModal()}
              className="modal-lg"
            >
              <ModalHeader
                style={{
                  background: "#f8f9fa",
                }}
                toggle={(event) => this.toggleFailedTransactionsViewModal()}
              >
                Past Due Payment
              </ModalHeader>
              <ModalBody
                style={{
                  background: "#f8f9fa",
                }}
              >
                <Row>
                  <Col>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th>Player Name</th>
                          <th>Event Name</th>
                          <th>Price</th>
                          <th>StartingAt</th>
                          <th>EndingAt</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.failedTransactions.map(
                          (failedTransaction, index) => (
                            <tr key={index}>
                              <td>
                                {failedTransaction.name
                                  ? failedTransaction.name
                                  : "-"}
                              </td>
                              <td>
                                {failedTransaction.camp &&
                                failedTransaction.camp.name
                                  ? failedTransaction.camp.name
                                  : "-"}
                              </td>
                              <td>
                                {failedTransaction.price
                                  ? failedTransaction.price.toFixed(2)
                                  : "0.00"}
                              </td>
                              <td>
                                {failedTransaction.camp &&
                                failedTransaction.camp.startingAt
                                  ? moment
                                      .utc(failedTransaction.camp.startingAt)
                                      .format("LL")
                                  : "-"}
                              </td>
                              <td>
                                {failedTransaction.camp &&
                                failedTransaction.camp.endingAt
                                  ? moment
                                      .utc(failedTransaction.camp.endingAt)
                                      .format("LL")
                                  : "-"}
                              </td>
                              <td
                                style={{
                                  cursor: "pointer",
                                  color: "blue",
                                }}
                                onClick={() =>
                                  this.renderPlayerPaymentDetailPage(
                                    failedTransaction.camp,
                                    failedTransaction.name,
                                    failedTransaction.transactionId
                                  )
                                }
                              >
                                View
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default RushUserEvents;
